import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

import Link from './Link';
import Logo from './Logo';

const Hero = ({ leadIn, title, image, children }) => (
  <div className="relative">
    <motion.img
      key={image}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      src={image}
      alt=""
      className="absolute inset-0 w-full h-full object-center object-cover"
    />
    <div className="absolute inset-0 gradient-horizontal" />
    <div className="container relative">
      <div className="max-w-4xl mx-auto text-center pt-8 pb-24 lg:py-32 text-shadow-lg">
        <Link href="/">
          <Logo className="w-32 mx-auto mb-8 lg:hidden" />
        </Link>
        <h1>
          {leadIn && (
            <span className="block uppercase text-white text-lg lg:text-2xl leading-tight mb-6">
              {leadIn}
            </span>
          )}
          <span className="block font-script text-accent leading-none text-6xl lg:text-9xl">
            {title}
          </span>
        </h1>

        {children}
      </div>
    </div>
  </div>
);

Hero.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  children: PropTypes.node,
  leadIn: PropTypes.string,
};

Hero.defaultProps = {
  children: null,
  leadIn: null,
};

export default Hero;
